<button class="btn btn-light btn-back buffer-top-left" (click)="back()">Back</button>


<div class="details-container" *ngIf="!editing">
  <div class="form-group">
    <label>Test Type</label>
    <ng-select [items]="plateTestTypes" autofocus bindLabel="testTypeName" bindValue="id" [virtualScroll]="true"
               placeholder="Please Select" [(ngModel)]="plateTestTypeId" (ngModelChange)="plateTestTypeChanged()">
    </ng-select>
  </div>
</div>

<div class="loader-container" *ngIf="loading">
  <div class="loader"></div>
</div>

<div class="main-container" *ngIf="(editing || plateTestTypeId != undefined) && !loading">
  <div class="load-container">
    <div class="load-block" *ngFor="let load of test.jobPlateTestLoads">
      <label class="load label-table"style=" padding: 5px; width: 20%; text-align: center;margin-bottom:0px;">{{load.load}}</label>
      <input type="number" [(ngModel)]="load.load1" (change)="loadChanged(load)" />
      <input type="number" [(ngModel)]="load.load2" (change)="loadChanged(load)" />
      <input type="number" [(ngModel)]="load.load3" (change)="loadChanged(load)" />
      <label class="avg" style=" padding: 5px; width: 20%; text-align: center; margin-bottom: 0px;">{{load.avg}}</label>
    </div>

    <div class="totals" style="border: 1px solid #ccc; padding: 1%; ">
      <div><label>{{ test.force }} (Force to acheive 1.25mm deformation)</label></div>
      <div><label>{{ test.cbr }} (CBR (%))</label></div>
      <div><label>{{ test.k }} (K)</label></div>
    </div>

    <div class="btn-row">
      <button type="button" class="btn btn-success buffer-right" (click)="recalculate(false)">{{ButtonMsg}}</button>
      <button type="button" *ngIf="editing" class="btn btn-success buffer-left" (click)="update(true)">Update</button>
    </div>
  </div>

  <div class="remarks-container">
    <div class="form-group" style="width: 33%;">
      <label>Tested Date</label>
      <div class="date-wrapper">
        <div class="date-wrapper-wrapper">
          <input matInput [matDatepicker]="picker" class="form-control" [(ngModel)]="test.createdAt" style="width:90%">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        </div>
        <mat-datepicker #picker></mat-datepicker>
      </div>
    </div>

    <div style="display:flex;flex-direction:row">
      <div class="form-group" style="flex:1">
        <label>Customer Reference</label>
        <input type="text" class="form-control input-remarks" [(ngModel)]="customerReference" />
      </div>

      <div class="form-group" style="flex:1">
        <label>Location Reference</label>
        <input type="text" class="form-control input-remarks" [(ngModel)]="locationReference" />
      </div>
    </div>

    <div class="form-group">
      <label>Type of reaction Load</label>
      <ng-select [items]="reactionLoads" autofocus bindLabel="load" bindValue="load" [virtualScroll]="true"
                 placeholder="Please Select" [(ngModel)]="test.typeOfReactionLoad" (ngModelChange)="reactionLoadChanged()">
      </ng-select>
      <input *ngIf="showReactionLoadOther" type="text" class="form-control po" [(ngModel)]="otherReactionLoad" />
    </div>

    <div class="form-group">
      <label>Material</label>
      <ng-select [items]="materials" autofocus bindLabel="description" bindValue="materialId" [virtualScroll]="true"
                 placeholder="Please Select" [(ngModel)]="test.materialId">
      </ng-select>
    </div>

    <div class="form-group">
      <label>Remarks:</label>
      <input type="text" class="form-control input-remarks" [(ngModel)]="remarks" />
    </div>
    <div class="form-group" *ngIf="editing">
      <label>Reason for Re-issue:</label>
      <input type="text" class="form-control input-remarks" [(ngModel)]="reason_For_ReIssue" />
    </div>

    <div class="btn-row" *ngIf="!editing">

      <button type="button" class="btn btn-success buffer-left" (click)="update(true)">Save</button>
      <button type="button" class="btn btn-success buffer-left" (click)="update(false)">Save and Add</button>
    </div>
  </div>
</div>
